import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { LocalizationProvider as MuiLocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";

import { useLocales } from "./use-locales";

// ----------------------------------------------------------------------

const HTML_LANGUAGE_BY_APP_LANGUAGE: Record<string, string> = {
  hu: "hu",
  en: "en",
  srb: "sr",
  gre: "el",
  bg: "bg",
  fr: "fr",
  ger: "de",
};

type Props = {
  children: React.ReactNode;
};

export default function LocalizationProvider({ children }: Props) {
  const { currentLang } = useLocales();
  const { i18n } = useTranslation();
  const activeLanguage = (
    i18n.resolvedLanguage ||
    i18n.language ||
    currentLang.value
  )
    .toLowerCase()
    .split("-")[0];

  useEffect(() => {
    document.documentElement.lang =
      HTML_LANGUAGE_BY_APP_LANGUAGE[activeLanguage] ?? activeLanguage;
  }, [activeLanguage]);

  return (
    <MuiLocalizationProvider
      dateAdapter={AdapterDateFns}
      adapterLocale={currentLang.adapterLocale}
    >
      {children}
    </MuiLocalizationProvider>
  );
}
